import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asplab',
  templateUrl: './asplab.component.html',
  styleUrls: ['./asplab.component.scss']
})
export class AsplabComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
